import React, { forwardRef } from 'react';
import {
    Table, Typography, Row, Col, Divider
} from 'antd';
import locale from 'antd/es/locale/pt_BR';
import { MobileOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { stateGlobal } from '../../../../../interfaces/Global';
import { cardLayout } from '../../GridStyle';

// @ts-ignore
import ImagemLogo from '../../../../../assets/logo.png';
// @ts-ignore
import ImagemIcone from '../../../../../assets/icone.png';
// @ts-ignore
import ImageWaves from '../../../../../assets/waves.png';
import { convertMoedaUSParaBRInicioSemDigitos } from '../../../../../services/Conversores';

const { Text, Title } = Typography;

interface IProps {
    columns: any[];
    dataSource: any[];
    loading: boolean;
    refContagemDoFiltro: React.MutableRefObject<any[]>;
    propsState: any;
}

const TableWrapper = forwardRef<any, IProps>(({
    columns,
    dataSource,
    loading,
    refContagemDoFiltro,
    propsState
}, ref) => {
    return (
        <div ref={ref} className="tableRelatorioDispositivosAtivos_wrapper report-content">
            <Row className="header-report" justify={'space-between'}>
                <Col className="header-info">
                    <h1>Relatório de Dispositivos Ativos</h1>
                </Col>
                <Col className="header-logo">
                    <img
                        src={ImagemLogo}
                        alt="Icone"
                    />
                </Col>

            </Row>

            <div className="page">
                <Table
                    className="tableRelatorioDispositivosAtivos_print"
                    rowKey={(record) => record.id.toString()}
                    loading={loading}
                    columns={columns}
                    dataSource={dataSource}
                    size="small"
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource
                        }
                    }
                    // title={(registros) => {
                    //     return (
                    //         <div
                    //             style={{
                    //                 backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                    //                 padding: 10,
                    //                 margin: -8,
                    //                 marginBottom: 0.5
                    //             }}
                    //         >
                    //             <Text>
                    //                 {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                    //                     dataSource.length :
                    //                     refContagemDoFiltro.current.length} num total de ${dataSource.length} `}
                    //             </Text>
                    //         </div>
                    //     )
                    // }}
                    // footer={(registros) => {
                    //     return (
                    //         <div
                    //             style={{
                    //                 textAlign: 'end'
                    //             }}
                    //         >
                    //             <Text>
                    //                 {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                    //                     dataSource.length :
                    //                     refContagemDoFiltro.current.length} num total de ${dataSource.length} `}
                    //             </Text>
                    //         </div>
                    //     )
                    // }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: 'end'
                                }}
                            >
                                <Text>
                                    {`Total de ${convertMoedaUSParaBRInicioSemDigitos(dataSource.length.toString())} registros.`}
                                </Text>
                            </div>
                        )
                    }}
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: false,
                        pageSize: dataSource.length + 10,
                        position: [],
                        pageSizeOptions: []
                    }}
                    locale={locale.Table}
                />
            </div>

            <div className="footer-report">
                <div>
                    <img
                        width={'200px'}
                        style={{
                            // position: 'absolute',
                            // bottom: 0,
                            // right: 0,
                            // marginBottom: '50px',
                            // marginRight: '15mm',
                            padding: '15px',
                        }}
                        src={ImagemLogo}
                        alt="Logo do Sistema"
                        className="logo-img"
                    />
                </div>
                <div className="footer-report-date-generated">
                    <p>
                        Arquivo gerado em {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR", {
                            hour: "2-digit",
                            minute: "2-digit"
                        })}
                    </p>
                </div>

                {/* <img className="footer-report-img" alt='Imagem rodapé' src={ImageWaves} width="100%" /> */}
            </div>
        </div>
    );
});

TableWrapper.displayName = 'TableWrapper';

export default TableWrapper;